import { useGetApiWorkspacesByIdObservabilityTimelineQuery } from '@/model/observability/api.generated';
import type { TimelineResponse } from '@/model/observability/dto.generated';
import { skipToken } from '@reduxjs/toolkit/query/react';

type ActivityTimelineArgs = { workspaceId: string; correlationId: string };

export const useActivityTimeline = (
  args: ActivityTimelineArgs | typeof skipToken,
  options?: { pollingInterval?: number },
): { data: TimelineResponse | undefined; isLoading: boolean; isError: boolean } => {
  const queryArgs =
    args === skipToken ? skipToken : { id: args.workspaceId, correlationId: args.correlationId };
  const { data, isLoading, isError } = useGetApiWorkspacesByIdObservabilityTimelineQuery(
    queryArgs,
    options,
  );
  return { data: data?.data, isLoading, isError };
};
